import { Task } from "@common/types/task";
import { hasSeparateChatPanel } from "@common/constants/taskTypeDefinitions";
import { TaskDetailPanelType } from "./constants";

/**
 * The right pane's tabs for a task, in display order: Chat and Details. Tasks
 * whose body is the chat have only Details. The first tab is the one a task
 * opens on.
 */
export const getTaskDetailPanelTabs = (
    task: Pick<Task, "type" | "thread">,
): TaskDetailPanelType[] =>
    task.thread && hasSeparateChatPanel(task.type)
        ? ["chat", "detail"]
        : ["detail"];

/** The tab to show: the requested one when the task has it, else its first tab. */
export const resolveTaskDetailPanelTab = ({
    tabs,
    requestedTab,
}: {
    tabs: TaskDetailPanelType[];
    requestedTab: TaskDetailPanelType | null;
}): TaskDetailPanelType =>
    requestedTab && tabs.includes(requestedTab) ? requestedTab : tabs[0];
